import { render, staticRenderFns } from "./plan-life-data.vue?vue&type=template&id=6e6bc31d"
import script from "./plan-life-data.vue?vue&type=script&lang=ts"
export * from "./plan-life-data.vue?vue&type=script&lang=ts"
import style0 from "./plan-life-data.vue?vue&type=style&index=0&id=6e6bc31d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports